import { getNestedProperty } from '@opallabs/lambda'
import { Moment, MomentCollection, State, StateKeys } from '../../../../types'

type GetMoments = (state: State) => MomentCollection | undefined
type GetMomentById = (state: State, id: string) => Moment | undefined

export const getMoments: GetMoments = (state) =>
  getNestedProperty<MomentCollection>(
    state,
    StateKeys.jsonApiEntities,
    StateKeys.moment
  )

export const getMomentById: GetMomentById = (state, id) =>
  getNestedProperty<Moment>(
    state,
    StateKeys.jsonApiEntities,
    StateKeys.moment,
    id
  )
